import { PayloadAction } from '@reduxjs/toolkit';
import { Annotation } from '@api/domain/types/annotations';
import { AnnotationsState } from '@reducers/v2/annotationsV2/annotationsV2.slice';

export const updateAnnotationAction = (state: AnnotationsState, action: PayloadAction<{ annotation: Annotation }>) => {
  const { annotation } = action.payload;
  const { documentId, pageNumber, id } = annotation;

  const pageAnnotations = state.byDocument[documentId]?.[pageNumber];
  if (!pageAnnotations) {
    return;
  }
  const index = pageAnnotations.findIndex((a) => a.id === id);
  if (index === -1) {
    return;
  }
  pageAnnotations[index] = annotation;
};
